module.exports = __webpack_public_path__ + "img/kiin.8aaf45ce.png";